import clsx from 'clsx'
import React from 'react'

type Props = {
  className?: string
  children?: any
  height?: number | string
  minHeight?: number | string
}

const TableBody: React.FC<Props> = ({className, children, height = 560, minHeight = '50vh'}) => {
  return (
    <div
      className={clsx(
        `card-body py-0 d-flex flex-column overflow-x-hidden overflow-y-auto`,
        className
      )}
      style={{height, minHeight}}
    >
      {children}
    </div>
  )
}

export {TableBody}
